import { lazy } from "react";
import type { RouteObject } from "react-router";
import { POST_ROUTES } from "@/src/post/constants/post-routes.constants";

const PublicFeedPage = lazy(() => import("@/src/post/pages/public-feed.page"));
const FeedPage = lazy(() => import("@/src/post/pages/feed.page"));
const PostDetailPage = lazy(() => import("@/src/post/pages/post-detail.page"));

/**
 * Public (PublicLayout) routes — read-only feed.
 * Post detail is dual-mode: comment/like actions only rendered when the
 * viewer is authed. Mounting under the public tree lets logged-out users
 * see a single post.
 */
export const postPublicRoutes: RouteObject[] = [
	{ path: POST_ROUTES.feed, element: <PublicFeedPage /> },
	{ path: POST_ROUTES.feedDetailPattern, element: <PostDetailPage /> },
];

/**
 * Authed (AuthedLayout > ProtectedRoute) routes — interactive feed +
 * compose, mounted under `/app/feed` to avoid collision with the public
 * `/feed`. Detail is mounted here too so signed-in users never leave the
 * authed shell when opening a post.
 */
export const postAuthedRoutes: RouteObject[] = [
	{ path: POST_ROUTES.appFeed, element: <FeedPage /> },
	{ path: POST_ROUTES.appFeedDetailPattern, element: <PostDetailPage /> },
];
